import axios from "axios";
import _ from "lodash";

import {
  GET_FREE_TRIAL_INITIATED,
  GET_FREE_TRIAL_SUCCESS,
  GET_FREE_TRIAL_ERROR,
  FREE_TRIAL_CLEAR,
} from "../../../constants/actionTypes/actionTypes";

export const startFreeTrial = () => (dispatch, getState) => {
  const {
    paths: { api },
  } = getState();
  const url = `${api}/v3/subscription/trial`;
  dispatch({ type: GET_FREE_TRIAL_INITIATED });
  return axios
    .post(url)
    .then((response) => {
      dispatch({
        type: GET_FREE_TRIAL_SUCCESS,
        data: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_FREE_TRIAL_ERROR,
        error: _.get(
          error,
          "response.data.body.endUserMessage",
          "Something went wrong, Please try later",
        ),
      });
    });
};

export const clearTrialDetails = () => ({
  type: FREE_TRIAL_CLEAR,
});
